import React from 'react';
import SchemaViewer from '../../elements/schema-viewer/SchemaViewer';
import { DATA_CHARS_ENABLED } from '../../../constants/config';
import {
  SCHEMA_DISPLAY_NUM_SAMPLES_DEFAULT,
  SCHEMA_DISPLAY_LIVE_SAMPLES_DEFAULT,
} from '../../../constants/schemaEditor';

class AvailableDataSetDataBrowser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      numSamples: SCHEMA_DISPLAY_NUM_SAMPLES_DEFAULT,
      liveSamples: SCHEMA_DISPLAY_LIVE_SAMPLES_DEFAULT,
    };

    this._handleRefreshSamples = this._handleRefreshSamples.bind(this);
    this._handleNumSamplesChanged = this._handleNumSamplesChanged.bind(this);
  }

  componentDidMount() {
    this._handleRefreshSamples();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.numSamples !== this.state.numSamples ||
      prevState.liveSamples !== this.state.liveSamples ||
      prevProps.data.id !== this.props.data.id
    ) {
      this._handleRefreshSamples();
    }
  }

  _handleRefreshSamples() {
    this.props.fetchDataSamples(this.props.data.id, this.state.numSamples, this.state.liveSamples);

    if (DATA_CHARS_ENABLED) {
      this.props.fetchCharacteristics(this.props.data.id);
    }
  }

  _handleNumSamplesChanged(optionValue) {
    const { count, live } = optionValue;

    this.setState({
      numSamples: count,
      liveSamples: live,
    });
  }

  render() {
    const { numSamples, liveSamples } = this.state;

    return (
      <div className="tab-content preview-tab">
        <SchemaViewer
          dataSet={this.props.data}
          schema={this.props.dataSetSchema ? this.props.dataSetSchema.out : null}
          samples={this.props.dataSetSamples?.samples}
          nestedSamples={this.props.dataSetSamples?.nestedSamples}
          numSamples={numSamples}
          liveSamples={liveSamples}
          onRefreshSamples={this._handleRefreshSamples}
          characteristics={this.props.dataSetSamples?.characteristics}
          samplesUpdatedAt={this.props.dataSetSamples?.lastUpdated}
          isLoadingSamples={this.props.isLoadingSamples}
          onNumSamplesChanged={this._handleNumSamplesChanged}
        />
      </div>
    );
  }
}

export default AvailableDataSetDataBrowser;
